/**
 * Moved to `@sizzlenz/shared-frontend/providers`.
 * Re-exported here so existing `@/components/SessionState` imports keep working.
 */
export { SessionStateProvider, useSessionState } from '@sizzlenz/shared-frontend/providers';
